import { render, staticRenderFns } from "./AppTemplate.vue?vue&type=template&id=e50eaa28&scoped=true&"
import script from "./AppTemplate.vue?vue&type=script&lang=ts&"
export * from "./AppTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AppTemplate.vue?vue&type=style&index=0&id=e50eaa28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50eaa28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBadge,VBtn,VDialog,VIcon,VSnackbar})
